<template lang="pug">
div(v-if="has_permission")
  modal-project-detail(:detail='detail', :is-add='isModalAdd', :project_id="inOrder.id")
  modal-image(:title="'Example Id for excel'").image_index
  modal-import-scope(:project_id="inOrder.id" :title="$t('front.import_modal', {model: $t('strings.scope')})")
  modal-scope-fabricated-history
  modal-category(:newRecord="newRecord")
  .container
        vm-button.btn_scope(size="mdium" @click="filterIncompletedCategories(categories)") Incomplete Shipments
        vm-button.btn_scope(size="mdium" @click="getCategories()") All Shipments
        vm-row(vm-w="12")
        vm-col(vm-type="flex" vm-justify="flex-end" vm-lg=12 vm-sm=12 v-if="update_scope_permission")
            vm-date-picker(v-model="date" :currentDate="date" :disabled="form.length === 0")
            vm-tooltip(text="Save scope" delay=".02s" position="left")
            vm-button.btn_scope(size="small" icon="save-outline" @click="setScope" :disabled="form.length === 0 || isInvalid" v-if="inOrder.status != 5")
            vm-tooltip(text="New Detail" delay=".02s" position="left")
            vm-button.btn_scope(size="small" icon="plus"  @click="addDetail")
            vm-tooltip(text="Import" delay=".02s" position="left")
            vm-button.btn_scope(size="small" icon="upload-outline" @click="setModalImportScopeVisible(true)")
        vm-col.card(vm-sm=12)
            expanded-scope.expanded(v-for="(item, index) in categories" :category="item" @set-fabricated="setFabricated" @history="setFabricatedHistory" :reset="reset" @delete="deleteDetailConfirm" @edit="editDetail")
            vm-row(vm-type="flex" vm-justify="flex-end" vm-lg=12 vm-sm=12 v-if="update_scope_permission")
                vm-button.btn_set(size="small" icon="save-outline" @click="setScope" :disabled="form.length === 0 || isInvalid" v-if="inOrder.status != 5")
</template>

<script>
import ModalImage from '@/components/in-order/ModalImage.vue'
import ModalProjectDetail from '@/components/in-order/ModalProjectDetail.vue'
import ModalCategory from '@/components/in-order/ModalCategory.vue'
import ExpandedScope from '@/components/in-order/ExpandedScope.vue'
import moment from 'moment'
import { createNamespacedHelpers } from 'vuex'
const { mapGetters, mapActions } = createNamespacedHelpers('InOrders')

export default {
  name: 'Scope',
  components: {
    ModalImage,
    ModalProjectDetail,
    ModalCategory,
    ExpandedScope,
    ModalImportScope: () => import('@/components/in-order/ModalImportScope.vue'),
    ModalScopeFabricatedHistory: () => import('@/components/in-order/ModalScopeFabricatedHistory.vue')
  },
  data: () => ({
    form: [],
    date: moment().format('YYYY-MM-DD HH:mm:ss'),
    reset: false,
    isModalAdd: true,
    isInvalid: true,
    newRecord: {},
    has_permission: true,
    update_scope_permission: true,
    detail: {}
  }),
  async created () {
    this.checkPermission('scopes.index')
    this.getCatalog()
    await this.getCategories()
  },
  methods: {
    ...mapActions([
      'loadCategoriesForScope',
      'setModalScopeVisible',
      'setModalImageVisible',
      'updateScope',
      'setModalScopeFabricatedHistoryVisible',
      'setModalImportScopeVisible',
      'fabricatedDetails',
      'getShippedDetails',
      'loadCatalog',
      'deleteProjectDetail'
    ]),
    async filterIncompletedCategories (categories) {
      categories.forEach((item, index) => {
        item.details.forEach((detail, detailIndex) => {
          const shipped = detail.shipped
          const [shippedValue, totalValue] = shipped.split('/').map(Number)
          if (shippedValue === totalValue) {
            item.details.splice(detailIndex, 1)
          }
        })
      })
    },
    async getCategories () {
      this.loadCategoriesForScope(this.$route.params)
    },
    async getCatalog () {
      this.loadCatalog({ url: 'categories', filter: 'is_active=1' })
    },
    checkPermission (permission) {
      this.has_permission = this.$auth.user().view_permissions.findIndex(e => e.name === permission) > -1
      this.update_scope_permission = this.$auth.user().view_permissions.findIndex(e => e.name === 'scopes.update') > -1
    },
    beforeRouteLeave (to, from, next) {
      this.updateScope({ id: this.$route.params.id, form: this.form, fabricated_date: this.date })
      next()
    },
    addDetail () {
      this.isModalAdd = true
      this.setModalScopeVisible(true)
      this.detail = {}
    },
    editDetail (data) {
      this.isModalAdd = false
      this.setModalScopeVisible(true)
      this.detail = { ...data.detail }
      this.detail.category = data.category
    },
    async setFabricatedHistory (item) {
      await this.fabricatedDetails(item)
      await this.getShippedDetails(item)
      this.setModalScopeFabricatedHistoryVisible(true)
    },
    setFabricated (data) {
      let idx = this.form.findIndex(e => parseInt(e.scope_id) === parseInt(data.scope_id))
      if (data.val > 0 && data.val <= parseInt(data.limit)) {
        parseInt(idx) < 0 ? this.form.push(data) : (this.form[idx].val = data.val)
        this.isInvalid = false
      } else if (data.scope_id === this.form[idx].scope_id) {
        this.form.splice(idx, 1)
        this.isInvalid = true
      }
    },
    async setScope () {
      await this.updateScope({ id: this.$route.params.id, form: this.form, fabricated_date: moment(this.date).format('YYYY-MM-DD HH:mm:ss') })
      this.reset = true
      this.form = []
    },
    doReset () {
      this.reset = false
    },
    async deleteDetailConfirm (detail) {
      let t = this
      this.auxDeleteDetail = () => {
        t.deleteProjectDetail(detail).then(() => {
          t.selected = []
          this.getCategories()
        })
      }
      this.$vm.dialog({
        color: 'danger',
        title: this.$t('front.delete_modal'),
        text: this.$t('strings.confirm_deletion'),
        accept: this.auxDeleteDetail
      })
    }
  },
  computed: {
    ...mapGetters([
      'inOrder',
      'categories'
    ])
  }
}
</script>
<style lang="scss">
.container {
  padding: 20px;
}
.btn_set {
  margin: 20px 20px;
}
.btn_scope {
  margin: 0px 10px;
}
.image_index {
  z-index: 999990 !important;
}
.history-button {
  height: 40px;
  width: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  &:hover {
    background: rgba($color: #000000, $alpha: 0.1);
    border-radius: 5px;
  }
}
</style>
